module.exports = __webpack_public_path__ + "static/media/icon_accounting.db596a9b.svg";